import * as React from "react";
import ILabelProps from "./IProps";
import "../../../assets/sass/widgets/label.scss";

/**
 * @class Label
 * @category Widgets
 * @description To display the title for the section on the form like product details , addedums
 */
class LabelWidget extends React.Component<ILabelProps, {}> {
    render() {
        const { id, schema } = this.props;
        const optional = schema.const.optional;
        return (
            <legend id={id} className="title-lbl">
                {schema.title} {optional && <span className="optional-txt">(Optional)</span>}
            </legend>
        );
    }
}

export default LabelWidget;
